/* 9TSEVEN theme scripts */
(() => {
  const store = {
    get(key, fallback) { try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch (e) { return fallback; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} },
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Money ---------- */
  const formatMoney = (cents) => {
    const format = (window.theme && window.theme.moneyFormat) || '{{amount}} kr';
    const n = Number(cents) / 100;
    const fmt = (decimals, thousands, decimal) => {
      const [int, frac] = n.toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fmt(2, ',', '.'),
      amount_no_decimals: fmt(0, ',', '.'),
      amount_with_comma_separator: fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
      amount_with_apostrophe_separator: fmt(2, "'", '.'),
    }[key] || fmt(2, ',', '.')));
  };

  /* ---------- Header menus (SHOP ‚ñ∏, LOOKBOOK ‚ñ∏): one open at a time ---------- */
  const toggles = [...document.querySelectorAll('[data-menu]')];
  const openMenu = (id) => {
    toggles.forEach((t) => {
      const open = t.getAttribute('aria-controls') === id;
      t.setAttribute('aria-expanded', String(open));
      const menu = document.getElementById(t.getAttribute('aria-controls'));
      if (menu) menu.hidden = !open;
    });
  };
  toggles.forEach((t) => t.addEventListener('click', () => {
    openMenu(t.getAttribute('aria-expanded') === 'true' ? null : t.getAttribute('aria-controls'));
  }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') openMenu(null); });

  // Mark links that match the current URL (including ?season= links), then open their menu
  const here = location.pathname + location.search;
  document.querySelectorAll('.submenu a').forEach((a) => {
    const url = new URL(a.href, location.origin);
    if (url.pathname + url.search === here) a.classList.add('is-active');
  });
  const activeMenu = document.querySelector('.submenu .is-active');
  if (activeMenu) {
    openMenu(activeMenu.closest('.submenu').id);
  } else if (document.body.classList.contains('template-product')) {
    const shopMenu = [...document.querySelectorAll('.submenu')].find((m) => m.querySelector('a[href*="/collections"]'));
    if (shopMenu) openMenu(shopMenu.id);
  }

  /* ---------- Page content starts below the longest menu, however many links it has ---------- */
  const nav = document.querySelector('.nav');
  const fitHeader = () => {
    if (!nav || !nav.firstElementChild) return;
    const line = nav.firstElementChild.getBoundingClientRect().height;
    let rows = nav.querySelectorAll(':scope > a, :scope > button').length;
    nav.querySelectorAll('.submenu').forEach((menu) => {
      rows = Math.max(rows, (parseInt(menu.style.getPropertyValue('--row'), 10) || 0) + menu.children.length);
    });
    const space = Math.ceil(nav.getBoundingClientRect().top + rows * line + 24);
    document.documentElement.style.setProperty('--header-space', `${space}px`);
  };
  fitHeader();
  window.addEventListener('resize', fitHeader);

  /* ---------- Cart count ---------- */
  const setCount = (n) => document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n ? `(${n})` : ''; });

  /* ---------- Home: logo stays put and fades out as you scroll ---------- */
  const logo = document.querySelector('[data-fade-logo]');
  const cover = document.querySelector('.cover');
  const bars = [document.querySelector('.header'), document.querySelector('.footer')].filter(Boolean);
  // Header and footer turn solid white while the cover photo is behind them
  const updateBars = () => {
    const edge = cover ? cover.getBoundingClientRect() : null;
    bars.forEach((bar) => {
      const box = bar.getBoundingClientRect();
      bar.classList.toggle('on-photo', !!edge && edge.top < box.bottom && edge.bottom > box.top + box.height / 2);
    });
  };
  updateBars();
  window.addEventListener('resize', updateBars);
  const onScroll = () => {
    updateBars();
    if (logo) logo.style.opacity = Math.max(0, 1 - window.scrollY / (window.innerHeight * 0.6));
    if (document.body.classList.contains('is-home') && window.scrollY > window.innerHeight * 0.7) showSignup(800);
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Collection "View 2 3 4" ---------- */
  document.querySelectorAll('[data-collection]').forEach((section) => {
    const buttons = [...section.querySelectorAll('[data-cols]')];
    const set = (cols) => {
      section.style.setProperty('--cols', cols);
      buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cols === String(cols))));
    };
    const saved = store.get('9t7-cols', null);
    if (saved && buttons.some((b) => b.dataset.cols === String(saved))) set(saved);
    buttons.forEach((b) => b.addEventListener('click', () => { set(b.dataset.cols); store.set('9t7-cols', Number(b.dataset.cols)); }));
  });

  /* ---------- Lookbook: ?season=ss26 shows only that season ---------- */
  const season = new URLSearchParams(location.search).get('season');
  const seasons = [...document.querySelectorAll('[data-season]')];
  if (season && seasons.some((s) => s.dataset.season === season)) {
    seasons.forEach((s) => { s.hidden = s.dataset.season !== season; });
  }

  /* ---------- Product form ---------- */
  document.querySelectorAll('[data-product]').forEach((section) => {
    const form = section.querySelector('form[action*="/cart/add"]');
    const json = section.querySelector('[data-variants]');
    if (!form || !json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = form.querySelector('input[name="id"]');
    const add = form.querySelector('[data-add]');
    const added = section.querySelector('[data-added]');
    const error = section.querySelector('[data-error]');
    const price = section.querySelector('[data-price]');
    const inputs = [...form.querySelectorAll('[data-option]')];
    const strings = (window.theme && window.theme.strings) || {};
    const optionCount = new Set(inputs.map((i) => i.name)).size;

    const selected = () => Array.from({ length: optionCount }, (_, i) => form.querySelector(`[name="option${i + 1}"]:checked`)?.value);
    const match = (sel) => variants.find((v) => v.options.every((o, i) => o === sel[i]));

    const update = () => {
      const sel = selected();
      inputs.forEach((input) => {
        const i = Number(input.name.replace('option', '')) - 1;
        const test = [...sel]; test[i] = input.value;
        const v = match(test);
        input.closest('.pill').classList.toggle('out', !v || !v.available);
      });
      const v = match(sel);
      add.disabled = !v || !v.available;
      add.textContent = !v ? strings.unavailable : v.available ? strings.addToCart : strings.soldOut;
      if (!v) return null;
      idInput.value = v.id;
      if (price) {
        price.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ` <s>${formatMoney(v.compare_at_price)}</s>` : '');
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
      return v;
    };

    inputs.forEach((i) => i.addEventListener('change', () => { if (added) added.hidden = true; update(); }));
    if (inputs.length) update();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      add.disabled = true;
      add.textContent = strings.adding;
      if (error) error.hidden = true;
      try {
        const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message);
        const cart = await fetch(`${root}cart.js`).then((r) => r.json());
        setCount(cart.item_count);
        if (added) added.hidden = false;
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      } finally {
        if (inputs.length) update();
        else { add.disabled = false; add.textContent = strings.addToCart; }
      }
    });
  });

  /* ---------- Newsletter popup: once, only after shop intent or scrolling past the cover ---------- */
  const signup = document.querySelector('[data-signup]');
  let signupTimer = null;
  function showSignup(delay) {
    if (!signup || signupTimer || !signup.hidden || store.get('9t7-signup', false)) return;
    signupTimer = setTimeout(() => {
      signup.hidden = false;
      requestAnimationFrame(() => signup.classList.add('is-open'));
    }, delay);
  }
  if (signup) {
    const close = () => {
      store.set('9t7-signup', true);
      signup.classList.remove('is-open');
      setTimeout(() => { signup.hidden = true; }, 350);
    };
    signup.querySelector('[data-signup-close]').addEventListener('click', close);

    if (signup.dataset.state === 'success' || signup.dataset.state === 'error') {
      // Coming back from the form post: show the result straight away
      if (signup.dataset.state === 'success') { store.set('9t7-signup', true); setTimeout(close, 4000); }
      signup.hidden = false;
      requestAnimationFrame(() => signup.classList.add('is-open'));
    } else if (signup.dataset.enabled === 'true' && !(window.Shopify && window.Shopify.designMode)) {
      const shopTemplates = ['template-collection', 'template-product', 'template-list-collections'];
      if (shopTemplates.some((c) => document.body.classList.contains(c))) showSignup(Number(signup.dataset.delay || 2500));
    }

    // Theme editor: show it while the section is selected
    document.addEventListener('shopify:section:select', (e) => {
      if (signup.closest(`#shopify-section-${e.detail.sectionId}`)) { signup.hidden = false; signup.classList.add('is-open'); }
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      if (signup.closest(`#shopify-section-${e.detail.sectionId}`)) { signup.classList.remove('is-open'); signup.hidden = true; }
    });
  }
})();
